// Global site navigation scaffold.

import { Link, NavLink } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Navbar() {
  const { lang, toggleLanguage, t } = useLanguage();
  const navLabels = t.navbar.items;
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const Logo = (
    <Link to="/" className="logo" id="logo">
      <img src="/logo-header.png" alt="Khubzah Solutions Logo" />
    </Link>
  );

  const navClassName = useMemo(
    () => (menuOpen ? "nav-active" : ""),
    [menuOpen]
  );

  useEffect(() => {
    document.body.classList.toggle("nav-menu-open", menuOpen);
    return () => document.body.classList.remove("nav-menu-open");
  }, [menuOpen]);

  const NavLinks = (
    <nav className={navClassName} onClick={(e) => e.stopPropagation()}>
      <NavLink to="/" end>
        {navLabels[0]}
      </NavLink>
      <NavLink to="/services" onClick={closeMenu}>
        {navLabels[1]}
      </NavLink>
      <NavLink to="/packages" onClick={closeMenu}>
        {navLabels[2]}
      </NavLink>
      <NavLink to="/about" onClick={closeMenu}>
        {navLabels[3]}
      </NavLink>
      <NavLink to="/contact" onClick={closeMenu}>
        {navLabels[4]}
      </NavLink>

      {/* Mobile-only language toggle inside menu */}
      <button
        type="button"
        className="lang-btn nav-lang-btn"
        onClick={toggleLanguage}
      >
        {lang === "ar" ? "EN" : "AR"}
      </button>
    </nav>
  );

  const LangButton = (
    <button type="button" className="lang-btn" onClick={toggleLanguage}>
      {lang === "ar" ? "EN" : "AR"}
    </button>
  );

  const MenuButton = (
    <button
      type="button"
      className="menu-icon"
      aria-label="Menu"
      aria-expanded={menuOpen}
      onClick={() => setMenuOpen((v) => !v)}
    >
      <span className={`bar ${menuOpen ? "open" : ""}`} />
      <span className={`bar ${menuOpen ? "open" : ""}`} />
      <span className={`bar ${menuOpen ? "open" : ""}`} />
    </button>
  );

  return (
    <header className={menuOpen ? "nav-open" : ""}>
      <div className="nav-container">
        {menuOpen && (
          <div
            className="nav-backdrop"
            aria-hidden="true"
            onClick={closeMenu}
          />
        )}
        {lang === "ar" ? (
          <>
            {MenuButton}
            {NavLinks}
            {Logo}
            {LangButton}
          </>
        ) : (
          <>
            {Logo}
            {NavLinks}
            {MenuButton}
            {LangButton}
          </>
        )}
      </div>
    </header>
  );
}

